import type { ActionSettingDefinition, DeviceSettingDefinition, PreferenceSettingDefinition, SettingsActionId, SettingsDeviceSettingId } from '../models/settings-hub.model';

/** The properties of a preference setting that the builders do not set */
type PreferenceExtras = Partial<Omit<PreferenceSettingDefinition, 'control' | 'preferenceKey' | 'label'>>;

const preference = (control: PreferenceSettingDefinition['control']) =>
    (preferenceKey: PreferenceSettingDefinition['preferenceKey'], label: string, extras: PreferenceExtras = {}): PreferenceSettingDefinition => ({
        // The id of a setting is its preference, unless the same preference is shown more than once
        id: preferenceKey,
        preferenceKey,
        control,
        label,
        ...extras
    });

/** Builders of the settings that save a preference: `field.toggle(preferenceKey, label, extras)` */
export const field = {
    chips: preference('chips'),
    color: preference('color'),
    email: preference('email'),
    image: preference('image'),
    multiselect: preference('multiselect'),
    number: preference('number'),
    select: preference('select'),
    text: preference('text'),
    textarea: preference('textarea'),
    toggle: preference('toggle')
};

/** Builder of a switch of the device in use: the id of the setting is the one of the device setting */
export const deviceToggle = (deviceSettingId: SettingsDeviceSettingId, label: string, extras: Partial<Omit<DeviceSettingDefinition, 'control' | 'deviceSettingId' | 'label'>> = {}): DeviceSettingDefinition => ({
    id: deviceSettingId,
    control: 'device-toggle',
    deviceSettingId,
    label,
    ...extras
});

/** Builder of a setting that runs an action: the id of the setting is the one of the action */
export const action = (actionId: SettingsActionId, label: string, extras: Partial<Omit<ActionSettingDefinition, 'control' | 'actionId' | 'label'>> = {}): ActionSettingDefinition => ({
    id: actionId,
    control: 'action',
    actionId,
    label,
    ...extras
});
